import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23970bd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-four" }
const _hoisted_2 = { class: "content outer-package" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title global-title" }, "领先企业的算法工程师和数据科学家均在体验", -1))
const _hoisted_4 = { class: "compy-icon" }
const _hoisted_5 = { class: "compy-item" }
const _hoisted_6 = { class: "compy-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_阿里.png"),
            moveUrl: require('@/assets/img/home/logo_阿里1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_百度.png"),
            moveUrl: require('@/assets/img/home/logo_百度1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_华为.png"),
            moveUrl: require('@/assets/img/home/logo_华为1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_腾讯.png"),
            moveUrl: require('@/assets/img/home/logo_腾讯1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_京东.png"),
            moveUrl: require('@/assets/img/home/logo_京东1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_谷歌.png"),
            moveUrl: require('@/assets/img/home/logo_谷歌1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_shareit.png"),
            moveUrl: require('@/assets/img/home/logo_shareit1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_funplus.png"),
            moveUrl: require('@/assets/img/home/logo_funplus1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_meta.png"),
            moveUrl: require('@/assets/img/home/logo_meta1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"]),
          _createVNode(_component_Image, {
            url: require("@/assets/img/home/logo_TESTIN.png"),
            moveUrl: require('@/assets/img/home/logo_TESTIN1.png'),
            statue: false
          }, null, 8, ["url", "moveUrl"])
        ])
      ])
    ])
  ]))
}